import { AgendaPage } from "../agenda/agenda.page.tsx";

export function AgendaWidget() {
  return (
    <div className="flex h-full min-h-0 flex-col">
      <AgendaPage />
    </div>
  );
}
